// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"601":"6e92de98","603":"b39d2d46","787":"f321e970"}[chunkId] + ".chunk.js";
};